import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../regureStyles';
import { auditActionLabel } from '../../../utils/auditPresentation';

const AuditTab = ({ claim, S }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='#10b981' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
            <path d='M9 12l2 2 4-4' />
          </svg>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#10b981' }}>{t('screens.claimsScreen.detail.hashChainVerified', { count: (claim?.auditTrail || []).length })}</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            style={{
              padding: '8px 16px',
              background: '#fff',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 600,
              color: S.textSecondary,
              cursor: 'pointer',
            }}
          >
            {t('screens.claimsScreen.detail.verifyChain')}
          </button>
          <button
            style={{
              padding: '8px 16px',
              background: '#fff',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 600,
              color: S.textSecondary,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
              <polyline points='7 10 12 15 17 10' />
              <line x1='12' y1='15' x2='12' y2='3' />
            </svg>
            {t('screens.claimsScreen.detail.export')}
          </button>
        </div>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: `2px solid ${S.borderLight}` }}>
            {[t('screens.claimsScreen.detail.colTimestamp'), t('screens.claimsScreen.detail.colUser'), t('screens.claimsScreen.detail.colAction'), t('screens.claimsScreen.detail.colDetail'), t('screens.claimsScreen.detail.colIP')].map(h => (
              <th
                key={h}
                style={{ padding: '10px 12px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8 }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(claim?.auditTrail || []).map((a, i) => {
            // Presentation only — see utils/auditPresentation.js. The stored
            // row is untouched: `raw` carries the exact string that was
            // written and hashed, and it stays on screen beneath the derived
            // label so the evidence is never replaced, only re-ordered.
            const { label, raw } = auditActionLabel(t, a.action);
            return (
              <tr key={a.id} style={{ borderBottom: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}>
                {/* Was a raw ISO instant in UTC. Now the tenant's date format
                    and timezone, the same as every other timestamp. */}
                <td style={{ padding: '12px', fontSize: 12, color: S.textMuted, fontFamily: 'monospace' }}>{formatDateTime(a.time)}</td>
                <td style={{ padding: '12px', fontSize: 13, fontWeight: 500, color: S.textPrimary }}>{a.user}</td>
                <td style={{ padding: '12px', fontSize: 13, color: S.textSecondary }}>
                  <div>{label}</div>
                  {raw && (
                    <div style={{ fontSize: 11, color: S.textMuted, fontFamily: 'monospace', marginTop: 2 }} title={raw}>{raw}</div>
                  )}
                </td>
                <td style={{ padding: '12px', fontSize: 13, color: S.textSecondary }}>{a.detail}</td>
                <td style={{ padding: '12px', fontSize: 12, color: S.textMuted, fontFamily: 'monospace' }}>{a.ip}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AuditTab;
